import React from "react";
import Faq from "react-faq-component";
import "./faqs.scss";
import faq from "../../../assets/UMSImage/FAQs.png";

const Faqs = () => {
  const data = {
    // title: "FAQ (How it works)",
    rows: [
      {
        title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        defaultOpened: true,
        content:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, suscipit sit tenetur vitae similique animi esse incidunt obcaecati, at eveniet blanditiis iusto accusantium quia ratione cum, libero ea omnis autem. ",
      },
      {
        title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        content:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, suscipit sit tenetur vitae similique animi esse incidunt obcaecati, at eveniet blanditiis iusto accusantium quia ratione cum, libero ea omnis autem. ",
      },
      {
        title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        content:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, suscipit sit tenetur vitae similique animi esse incidunt obcaecati, at eveniet blanditiis iusto accusantium quia ratione cum, libero ea omnis autem. ",
      },
      {
        title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        content:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, suscipit sit tenetur vitae similique animi esse incidunt obcaecati, at eveniet blanditiis iusto accusantium quia ratione cum, libero ea omnis autem. ",
      },
      {
        title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        content:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, suscipit sit tenetur vitae similique animi esse incidunt obcaecati, at eveniet blanditiis iusto accusantium quia ratione cum, libero ea omnis autem. ",
      },
    ],
  };

  const styles = {
    titleTextColor: "#1F3257",
    rowTitleColor: "#1F3257",
    // rowTitleTextSize:"1.125rem",
    rowContentPaddingBottom: "20px",
  };
  const config = {
    animate: true,
    openOnload: 0,
};

  return (
    <section id="faqs-wrapper">
      <div className="row">
        <div className="col-md-6 faqs-image">
          <img src={faq} alt="" className="faqs-image" />
        </div>
        <div className="col-md-6 faqs-content">
          <h1 className="faq-title-custom">
            <span> Don't Hesitate</span> to Ask, We Are Here for You.
          </h1>
          <Faq data={data} styles={styles} config={config} />
        </div>
      </div>
    </section>
  );
};

export default Faqs;
